import styled from "@emotion/styled";
import { Colors } from "../../../../../colors";



export const TableEventsReservationStyled = {
    AttendeesLimitBreakmessage: styled.p`
        font-size: 14px;
        font-family: EncodeSans-SemiBold;
        color: ${Colors.White};
    `
}